/**
 * PushBanner — la notifica arrivata ad app aperta, su Android (#126).
 *
 * Con l'app davanti Android non mostra le notifiche: la mostra l'app, in alto,
 * per qualche secondo. Toccarla fa quello che farebbe toccare la notifica.
 *
 * Props:
 *   - notice ({title, body}|null)
 *   - onOpen (fn): tocco sul banner
 *   - onDismiss (fn): sparisce da solo dopo 6 secondi
 */
import React, { useEffect } from "react";

export default function PushBanner({ notice, onOpen, onDismiss }) {
  useEffect(() => {
    if (!notice) return undefined;
    const t = setTimeout(onDismiss, 6000);
    return () => clearTimeout(t);
  }, [notice, onDismiss]);

  if (!notice) return null;

  return (
    <button
      type="button"
      role="status"
      onClick={onOpen}
      style={{
        position: "fixed", top: "calc(12px + env(safe-area-inset-top, 0px))", left: 12, right: 12,
        maxWidth: 460, margin: "0 auto", zIndex: 330, border: "none", cursor: "pointer", textAlign: "left",
        background: "var(--color-surface)", borderRadius: 20, padding: "14px 16px",
        boxShadow: "0 18px 44px -18px rgba(0,0,0,0.45)", display: "flex", gap: 12, alignItems: "center",
      }}
    >
      <span aria-hidden="true" style={{
        flexShrink: 0, width: 38, height: 38, borderRadius: 12, display: "grid", placeItems: "center", fontSize: 18,
        background: "linear-gradient(135deg, var(--color-primary), var(--color-primaryBright))",
      }}>🔔</span>
      <span style={{ minWidth: 0 }}>
        <span style={{ display: "block", fontFamily: "var(--font-display)", fontWeight: 800, fontSize: 15, color: "var(--color-text)" }}>
          {notice.title}
        </span>
        {notice.body && (
          <span style={{ display: "block", fontFamily: "var(--font-body)", fontSize: 13, color: "var(--color-textMuted)", marginTop: 2 }}>
            {notice.body}
          </span>
        )}
      </span>
    </button>
  );
}
